import Immutable from 'seamless-immutable';
import { AnyAction } from 'redux';

import {
  SET_DEEPLINK_DATA,
  RESET_DEEPLINK_DATA,
} from 'actions/analytics/deeplink';

const INITIAL_STATE = Immutable({
  data: null,
});

export default (state = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case SET_DEEPLINK_DATA: {
      return state.merge({ data: action.payload });
    }
    case RESET_DEEPLINK_DATA: {
      return INITIAL_STATE;
    }
    default:
      return state;
  }
};
